<template>
  <div class="account-footer text-right" v-if="selected_order">
    <router-link :to="{ name: 'profile.history' }" class="btn btn-outline">
      {{ _T('Back') }}
    </router-link>
    <router-link
      :to="{
        name: brandStoreRoute('store_page'),
        params: {
          brand_id: selected_order.brand_id,
          store_id: selected_order.store_id,
        },
      }"
      class="btn btn-solid"
    >
      {{ _T('Reorder') }}
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.225 10.0739C15.036 10.015 14.8314 10.0332 14.6558 10.1245C14.4802 10.2158 14.3478 10.3729 14.2875 10.5614C13.9332 11.6447 13.2424 12.5868 12.3157 13.2504C11.389 13.9141 10.2747 14.2648 9.135 14.2514C7.72526 14.2674 6.3667 13.7237 5.35723 12.7396C4.34776 11.7554 3.76977 10.4111 3.75 9.00139C3.76977 7.5917 4.34776 6.24737 5.35723 5.26321C6.3667 4.27904 7.72526 3.73536 9.135 3.75139C10.4082 3.74831 11.6422 4.19149 12.6225 5.00389L10.995 4.73389C10.8975 4.71784 10.7977 4.72123 10.7015 4.74386C10.6053 4.7665 10.5145 4.80794 10.4343 4.86579C10.3542 4.92364 10.2862 4.99676 10.2344 5.08096C10.1826 5.16515 10.148 5.25876 10.1325 5.35639C10.1165 5.45393 10.1198 5.55368 10.1425 5.6499C10.1651 5.74612 10.2065 5.83693 10.2644 5.91708C10.3223 5.99724 10.3954 6.06516 10.4796 6.11696C10.5638 6.16875 10.6574 6.20339 10.755 6.21889L13.935 6.74389H14.0625C14.1495 6.74378 14.2358 6.72856 14.3175 6.69889C14.345 6.68846 14.3704 6.67322 14.3925 6.65389C14.4463 6.63389 14.4968 6.60609 14.5425 6.57139L14.61 6.48889C14.61 6.45139 14.6775 6.42139 14.7075 6.37639C14.7375 6.33139 14.7075 6.30139 14.745 6.27139C14.7657 6.22771 14.7833 6.18259 14.7975 6.13639L15.36 3.13639C15.3787 3.03789 15.3778 2.93668 15.3574 2.83853C15.337 2.74037 15.2975 2.6472 15.2411 2.56432C15.1847 2.48144 15.1125 2.41049 15.0287 2.35551C14.9448 2.30053 14.851 2.2626 14.7525 2.24389C14.654 2.22517 14.5528 2.22604 14.4546 2.24644C14.3565 2.26685 14.2633 2.30638 14.1804 2.36279C14.0131 2.47672 13.8978 2.65247 13.86 2.85139L13.6575 3.93889C12.402 2.85082 10.7964 2.25171 9.135 2.25139C7.32745 2.23539 5.58738 2.93711 4.2966 4.20257C3.00583 5.46804 2.26979 7.19387 2.25 9.00139C2.26979 10.8089 3.00583 12.5347 4.2966 13.8002C5.58738 15.0657 7.32745 15.7674 9.135 15.7514C10.5999 15.7739 12.0332 15.3255 13.2241 14.4722C14.415 13.6188 15.3004 12.4057 15.75 11.0114C15.7784 10.9154 15.7874 10.8146 15.7763 10.7151C15.7651 10.6156 15.7342 10.5193 15.6853 10.4319C15.6363 10.3445 15.5704 10.2678 15.4914 10.2063C15.4123 10.1448 15.3217 10.0998 15.225 10.0739Z"
        ></path>
      </svg>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HistoryFooter',
  computed: {
    ...mapGetters(['_T', 'selected_order', 'brandStoreRoute']),
  },
}
</script>

<style lang="scss" scoped>
.account-footer {
  padding: $px18 $px40;
  border-top: $px1 solid $light-border;
  @media (max-width: 575px) {
    display: flex;
    justify-content: space-between;
    align-content: space-between;
    padding: 0;
    border-top: $px1 solid $light-border;
  }
  .btn {
    width: $px190;

    + .btn {
      margin-left: $px8;
    }
  }

  .btn-outline {
    border-color: $font-color;
    color: $font-color;

    &:hover,
    &:focus {
      background-color: $font-color;
      color: $white;
    }
  }

  .btn-solid {
    position: relative;

    &:hover,
    &:focus {
      svg {
        path {
          fill: $color-primary;
        }
      }
    }

    svg {
      position: absolute;
      left: $px18;
      top: $px10;

      path {
        fill: $white;
      }
    }
  }
}
</style>
